import { render, staticRenderFns } from "./LocalePickerInput.vue?vue&type=template&id=5d327c64&scoped=true"
import script from "./LocalePickerInput.vue?vue&type=script&lang=js"
export * from "./LocalePickerInput.vue?vue&type=script&lang=js"
import style0 from "./LocalePickerInput.vue?vue&type=style&index=0&id=5d327c64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d327c64",
  null
  
)

export default component.exports